import { END_POINT } from '../end-point';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

const logsAPI = {
  // 로그 전체 조회
  getLogsAPI: async () => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.get<any>(END_POINT.logsController.getLogs(), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  // 로그 단일 조회
  getLogsIdAPI: async (id: number) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.get<any>(END_POINT.logsController.getLogsId(id), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  // 로그 조회 - 로그인
  getLogsLoginAPI: async (params?: { page: number }) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.get<any>(END_POINT.logsController.getLogsLogin(), {
        params, // 페이지 정보 전달
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  // 로그 조회 - 환경설정
  getLogsSettingsAPI: async (params?: { page: number }) => {
    const accessToken = getAccessTokenFromCookies();

    try {
      const response = await httpService.get<any>(END_POINT.logsController.getLogsSettings(), {
        params, // 페이지 정보 전달
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export const { getLogsAPI, getLogsIdAPI, getLogsLoginAPI, getLogsSettingsAPI } = logsAPI;
